import React from "react";
import { css } from "emotion";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import { Button } from "@maxmilhas/hangar-components-atomic/public";

import { defaultStyle, contentStyle, titleStyle, descriptionStyle, buttonStyle } from "./style";

const ModalBottom = props => {
	const isDescriptionObject = typeof props.description === "object";

	return (
		<CSSTransition in={props.show} unmountOnExit timeout={1000}>
			<div
				className={css`
					${defaultStyle}
				`}
				style={{ position: props.fixed ? "fixed" : "absolute" }}
			>
				<div
					className={css`
						${contentStyle}
					`}
					style={{
						width: `${isNaN(props.width) ? props.width : props.width + "px"}`,
						minHeight: `${isNaN(props.minHeight) ? props.minHeight : props.minHeight + "px"}`
					}}
				>
					<a href="#" className="btn-green-md-icon close-button" onClick={props.close}>
						<i className="icon-close" />
					</a>
					<p
						className={css`
							${titleStyle}
						`}
					>
						<strong>{props.title}</strong>
					</p>
					{isDescriptionObject ? (
						<div
							className={css`
								${descriptionStyle}
							`}
						>
							{props.description}
						</div>
					) : (
						<div
							className={css`
								${descriptionStyle}
							`}
							dangerouslySetInnerHTML={{ __html: props.description }}
						/>
					)}
					<div
						className={css`
							${buttonStyle}
						`}
						style={{ justifyContent: !!props.cancel && "space-between" }}
					>
						{!!props.cancel && (
							<Button outline color={"#979797"} onClick={props.onCancel}>
								{props.cancel}
							</Button>
						)}
						<Button onClick={props.onConfirm}>{props.confirm}</Button>
					</div>
				</div>
			</div>
		</CSSTransition>
	);
};

ModalBottom.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	title: PropTypes.string,
	description: PropTypes.any,
	confirm: PropTypes.string.isRequired,
	onConfirm: PropTypes.func.isRequired,
	cancel: PropTypes.string,
	onCancel: PropTypes.func,
	show: PropTypes.bool,
	close: PropTypes.bool
};

ModalBottom.defaultProps = {
	width: "100%",
	minHeight: 283,
	show: false
};

export default ModalBottom;
